module.exports = __webpack_public_path__ + "691a8629d9493c84d2ef33b6fcfef57b.pdf";